import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


function RichTextContent({ className, variant, content, hasVerticalMargins }) {
    return (
        <div
            className={classNames(
                'rich-text',
                { 'no-vertical-margins': !hasVerticalMargins },
                { 'light-variant': variant === 'light' },
                className,
            )}

            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: content,
            }}
        />
    );
}

RichTextContent.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf([ 'dark', 'light' ]),
    content: PropTypes.string,
    hasVerticalMargins: PropTypes.bool,
};

RichTextContent.defaultProps = {
    className: undefined,
    variant: 'dark',
    content: undefined,
    hasVerticalMargins: true,
};

export default RichTextContent;
